// extracted by mini-css-extract-plugin
module.exports = {"iconTextButton":"IconTextButton_iconTextButton__2ucDV","text":"IconTextButton_text__3hOuk","delete":"IconTextButton_delete__1jFQI"};